/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type DashboardSiteContainer_site = {
    readonly id: string;
    readonly name: string;
    readonly createdAt: string;
    readonly " $refType": "DashboardSiteContainer_site";
};
export type DashboardSiteContainer_site$data = DashboardSiteContainer_site;
export type DashboardSiteContainer_site$key = {
    readonly " $data"?: DashboardSiteContainer_site$data;
    readonly " $fragmentRefs": FragmentRefs<"DashboardSiteContainer_site">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardSiteContainer_site",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
        }
    ],
    "type": "Site",
    "abstractKey": null
} as any;
(node as any).hash = '06bd5788bd91946939d2bd9bcf41e64d';
export default node;
